import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Start every page at the top. Without this, a page opened from the bottom
// of a long form (such as registration) appears scrolled part-way down.
// A link to a section of a page (such as /#features) scrolls to that section.
function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (hash) {
            // Wait a moment so the page the section belongs to is on screen.
            const timer = setTimeout(() => {
                const section = document.getElementById(hash.slice(1));
                if (section) section.scrollIntoView({ behavior: "smooth", block: "start" });
            }, 60);
            return () => clearTimeout(timer);
        }

        window.scrollTo(0, 0);
        return undefined;
    }, [pathname, hash]);

    return null;
}

export default ScrollToTop;
